import { render } from "./App.vue?vue&type=template&id=aa88643e&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=aa88643e&scoped=true&lang=css"
import "./App.vue?vue&type=style&index=1&id=aa88643e&lang=css"

import exportComponent from "/Users/neiloswald/Workspace/ionic/mtzoom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa88643e"]])

export default __exports__